module.exports = __webpack_public_path__ + "images/73a3ff6848495faae7ce391bbbe673ff.jpg";